import { takeEvery, call, select, put } from 'redux-saga/effects'

import { oneSignalInit } from 'libraries/oneSignal'
import { sendError } from 'store/entities/analytics/actions'
import { ERRORS } from 'store/entities/analytics/consts'
import { isOneSignalInitialized } from '../selectors'
import { initOneSignal, initOneSignalSuccess } from '../actions'

export function* handleInitOneSignal({ payload }) {
  if (process.env.NODE_ENV === 'development') {
    payload = '7843ba68-165e-45fe-8c6a-6d56f8c7c183'
  }
  try {
    const isInitialized = yield select(isOneSignalInitialized)
    if (!isInitialized && payload) {
      yield call(oneSignalInit, payload)
      yield put(initOneSignalSuccess())
    }
  } catch (error) {
    yield put(
      sendError({
        type: ERRORS.ONE_SIGNAL_INITIALIZATION,
        error,
      })
    )
  }
}

export default function* initOneSignalTakeEvery() {
  yield takeEvery(initOneSignal, handleInitOneSignal)
}
